import { useEffect } from "react";
import { connect } from "react-redux";

function LogoutUser(props) {


    useEffect(() => {


        const urlParams = new URLSearchParams(window.location.search);
        const red = urlParams.get('redirectUrl');
        const tenant = urlParams.get('tenant');


        if (red) {

            props.handleLogout()
            window.location.href = red;

        }
        else {

            window.location.href = "/login";
            props.handleLogout()
            props.dispatch({ type: "BG_LOADER", data: false })
        }
    }, []);

    const handleLogin = () => {
        // localStorage.clear();
        const keysToRemove = [
            'AccessTokenTAC',
            'UserInfoTAC',
            'isLoginTAC',
            'iscametoElseScopeTAC',
            'realmNameTAC',
            'redirectURLTAC',
            'userNameTAC',
            'idTokenTAC',
            'isSessionExpiredTAC',
            'isSSOConfigTAC'
        ];

        keysToRemove.forEach(key => localStorage.removeItem(key));
        // window.location.pathname = "/";
        window.location.pathname = "/admin/";
        // window.location.href = process.env.REACT_APP_LOGOUT;
    }

    return (<>

    </>)
}
const mapStateToProps = state => {
    return {

        BG_LOADER: state.userReducer.BG_LOADER,
        BG_HOME_LOADER: state.userReducer.BG_HOME_LOADER,
    }
}

const mapDispatchToProps = dispatch => {
    return {

        dispatch
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(LogoutUser);